import { memo } from "react";
import { Link } from "react-router-dom";

import { PROFILE, TRAINERS } from "../../../constants/router";
import { useFilteredMenuItems } from "../../../hooks/useFilteredMenuItems";
import { ClientDropDown } from "../ClientDropDown";
import { RefreshButton } from "../RefreshButton";
import { ToolsDropDown } from "../ToolsDropDown";

import { TOOLS_ITEMS } from "./../Menu.model";

export const CompanyAdminMenu = memo(
  ({ closeMenuAndResetEditableClientId, closeMenu, isCanAddCoaches }) => {
    const filteredMenu = useFilteredMenuItems();

    return (
      <>
        <div onClick={closeMenuAndResetEditableClientId} className="menu-item">
          <Link to={PROFILE.root} className="tools">
            my profile
          </Link>
        </div>
        {isCanAddCoaches && (
          <div
            onClick={closeMenuAndResetEditableClientId}
            className="menu-item"
          >
            <Link to={TRAINERS.root} className="tools">
              coaches
            </Link>
          </div>
        )}
        <ClientDropDown dropdownItems={filteredMenu} onClick={closeMenu} />
        <ToolsDropDown
          onClick={closeMenuAndResetEditableClientId}
          dropdownItems={TOOLS_ITEMS}
          value="tools"
        />
        <RefreshButton />
      </>
    );
  }
);
